import { generarAvisoDeVisita } from "../../services/detalleActa.service";
import { useActaDetalleStore } from "../../store/actaDetalleStore";
const { setAvisoVisita } = useActaDetalleStore.getState();

export const generarAvisoVisita = (id) => {
  const result = generarAvisoDeVisita(id);
  if (result) {
    setAvisoVisita(result);
  }else{
    console.error('No hay aviso de visita')
  }
};
